import React from 'react';
import { TaskId } from 'api/models';
import { TaskStatusPicker } from 'components/atoms/tasks';
import { Task } from 'data/tasks';
import { useNavigateToTask } from 'hooks/use-navigate-to-task';
import { TaskCardTitle } from '../../title';
import {
  CardSubTaskList,
  CardSubTaskListContainer,
} from './task-card-extra-footer.styles';

type TaskCardSubTasksPropTypes = {
  task: Task;
  subTasks: Task[];
};

export const TaskCardSubTasks = ({
  task,
  subTasks,
}: TaskCardSubTasksPropTypes) => {
  const navigateToTask = useNavigateToTask();

  const openTask = (taskId: number) => {
    navigateToTask(TaskId(task.project, taskId));
  };

  return (
    <CardSubTaskListContainer>
      {subTasks.map((subTask) => (
        <CardSubTaskList
          data-cy={subTask.taskName}
          onClick={(e) => {
            e.stopPropagation();
            openTask(subTask.taskId);
          }}
        >
          <TaskStatusPicker
            taskId={subTask.taskId}
            projectId={subTask.project}
            type={subTask.type}
            progress={subTask.progress}
            fields={subTask.fields}
          />

          <TaskCardTitle task={subTask} rows={1} />
        </CardSubTaskList>
      ))}
    </CardSubTaskListContainer>
  );
};
